const trustItems = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Daily',
    desc: 'New finds and verified sellers added every single day to keep your spreadsheet fresh and reliable.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted Sellers',
    desc: 'Every seller goes through our verification process — review history, quality feedback, and community reputation checked.',
  },
  {
    icon: 'ri-guide-line',
    title: 'Safe Buying Guides',
    desc: 'Complete QC guides, shipping comparisons, and safety tips to help you make informed purchasing decisions.',
  },
];

export default function TrustSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 md:mb-16">
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Why Trust Us</p>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Verified Finds.
              <br />
              <span className="text-foreground-400">Real Guides.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {trustItems.map((item) => (
              <div key={item.title} className="bg-background-50 rounded-lg p-6 md:p-8">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}